import { get } from "lodash";

export const getInstructionStep = (state) => get(state.itemInstructions, "step", "");

export const isInstructionEnableForStep = (step) => (state) => get(state.itemInstructions, "step", "") === step;

export const isInstructionHighlighted = (state) => get(state.itemInstructions, "highlight", false);
